/**
 * Get the current environment name from environment variables
 * @returns {string} - 'development', 'staging', or 'production' (defaults to 'development')
 */
export const getEnvironment = () => {
  const env =
    process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";

  // Normalize environment names
  const envLower = env.toLowerCase();

  if (envLower.includes("staging") || envLower.includes("stage")) {
    return "staging";
  }

  if (
    envLower.includes("production") ||
    envLower.includes("prod") ||
    envLower === "production"
  ) {
    return "production";
  }

  // Default to development
  return "development";
};

/**
 * Get environment display name
 * @returns {string} - 'DEV', 'STAGING', or 'LIVE'
 */
export const getEnvironmentDisplayName = () => {
  const env = getEnvironment();

  switch (env) {
    case "staging":
      return "STAGING";
    case "production":
      return "LIVE";
    default:
      return "DEV";
  }
};

/**
 * Get environment badge color
 * @returns {object} - Object with background and text colors
 */
export const getEnvironmentColors = () => {
  const env = getEnvironment();

  switch (env) {
    case "staging":
      return {
        bg: "#F59E0B", // Amber/Orange
        text: "#FFFFFF",
        border: "#D97706",
      };
    case "production":
      return {
        bg: "#EF4444", // Red
        text: "#FFFFFF",
        border: "#DC2626",
      };
    default:
      return {
        bg: "#10B981", // Green
        text: "#FFFFFF",
        border: "#059669",
      };
  }
};
